import React from 'react';

import { Skeleton } from '@mint-lib/tw-components';

const AgenticAiChatSkeleton = () => {
  return (
    <div
      className="flex h-full w-full flex-col gap-5"
      data-testid="chat-history-skeleton"
    >
      <Skeleton variant="rounded" className="h-19 w-full" />
      <Skeleton variant="rounded" className="h-4 w-full" />
      <Skeleton variant="rounded" className="h-19 w-full" />
      <Skeleton variant="rounded" className="h-57 w-full" />
      <Skeleton variant="rounded" className="h-19 w-full" />
    </div>
  );
};

export default AgenticAiChatSkeleton;
